import React, { Component } from 'react';
import ErrorTemplate from '../ErrorTemplate';

class Error500 extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error : {} };
      }


    static getDerivedStateFromError(error) {
        return { hasError: true, error: error.message };
      }
    
    componentDidCatch(error, errorInfo) {
        console.error("Unexpected error:", error, errorInfo);
      }  


  render() {
    const { hasError, error } = this.state;
    return (       
      <ErrorTemplate
        errorCode="500"
        errorMessage={hasError ? error : "Server Error"}
      />        
    );

  }
}

export default Error500;